import { Component } from '@angular/core';
import { AppConfig } from 'src/app/configs/app.config';
import { AppRoute } from 'src/app/constants/app.route';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { FormGroupService } from 'src/app/shared/form-error/form-group.service';
import { DestroyNotifierComponent } from 'src/app/core/component/destroy/destroy-notifier.component';
import { UserService } from 'src/app/core/services/http/user/user.service';
import { EventType } from 'src/app/constants/events-type';
import { EventManagerService } from 'src/app/core/services/event-manager/event-manager.service';
import { EventContent } from 'src/app/core/services/event-manager/models/event-content';

@Component({
  selector: 'app-email-verification-code',
  templateUrl: './email-verification-code.component.html',
  styleUrls: ['./email-verification-code.component.scss']
})
export class EmailVerificationCodeComponent extends DestroyNotifierComponent {
  appConfig = AppConfig;
  appRoute = AppRoute;
  verificationCode: string | undefined;
  isEmailVerified: boolean | undefined;
  emailVerificationMessage: string | undefined;

  form = new UntypedFormBuilder().group({
    verificationCodeInput: [, [Validators.required]]
  });

  constructor(
    private eventManager: EventManagerService,
    private formGroupService: FormGroupService,
    private userService: UserService
  ) {
    super();
  }

  verifyVerificaitonCode() {
    this.emailVerificationMessage = '';
    this.formGroupService.validateFormGroup(this.form);
    if (this.form.invalid) {
      return;
    }

    this.eventManager.broadcast(new EventContent(EventType.PreloaderShow, true));

    this.userService.verifyEmailCode(this.form.value.verificationCodeInput).subscribe((res: any) => {
      this.eventManager.broadcast(new EventContent(EventType.PreloaderShow, false));

      this.emailVerificationMessage = res.message;

      if (res.status) {
        this.isEmailVerified = true;
      } else {
        this.isEmailVerified = false;
        this.form.reset();
      }
    });
  }
}
